import { DefaultRenderService } from "./render-service";

import { RenderService } from "./constants";

export function bindRenderServiceModule({bind: bind}) {
    bind(RenderService).to(DefaultRenderService);
}

export default bindRenderServiceModule;
//# sourceMappingURL=render-modules.js.map
